import { isNative, nativePlatform } from "@/lib/native";
import api from "@/lib/api";

// RevenueCat public SDK keys (safe to ship in the app).
const sdkKey = () => (nativePlatform() === "ios" ? process.env.REACT_APP_RC_IOS_KEY : process.env.REACT_APP_RC_ANDROID_KEY);
export const iapAvailable = () => isNative() && !!sdkKey();

let configuredFor = null;
const rc = async () => (await import("@revenuecat/purchases-capacitor")).Purchases;

export async function ensureIap(userId) {
  if (!iapAvailable() || !userId) return false;
  if (configuredFor === userId) return true;
  const P = await rc();
  if (configuredFor === null) await P.configure({ apiKey: sdkKey(), appUserID: userId });
  else await P.logIn({ appUserID: userId });
  configuredFor = userId;
  return true;
}

export async function iapLogout() {
  if (!configuredFor || configuredFor === "$anon") return;
  try { await (await rc()).logOut(); } catch {}
  configuredFor = "$anon";
}

const tierRe = (tier) => new RegExp(`(^|[._:-])${tier}([._:-]|$)`);

export async function findPackage(tier, billing) {
  const offerings = await (await rc()).getOfferings();
  const pkgs = offerings?.current?.availablePackages || [];
  const yearly = billing === "yearly";
  return pkgs.find((p) => {
    const id = (p.product?.identifier || "").toLowerCase();
    const periodOk = yearly ? (p.packageType === "ANNUAL" || /year|annual/.test(id)) : (p.packageType === "MONTHLY" || /month/.test(id));
    return tierRe(tier).test(id) && periodOk;
  }) || null;
}

const syncPlan = () => api.post("/payments/revenuecat/sync").catch(() => null);

// Returns true on success, false when the user cancelled.
export async function purchasePackage(pkg) {
  try {
    await (await rc()).purchasePackage({ aPackage: pkg });
  } catch (e) {
    if (e?.userCancelled || e?.code === "1" || e?.code === 1) return false;
    throw e;
  }
  await syncPlan();
  return true;
}

export async function restorePurchases() {
  await (await rc()).restorePurchases();
  const r = await syncPlan();
  return r?.data?.plan || "free";
}

export async function openManageSubscription() {
  const { customerInfo } = await (await rc()).getCustomerInfo();
  const url = customerInfo?.managementURL
    || (nativePlatform() === "ios" ? "https://apps.apple.com/account/subscriptions" : "https://play.google.com/store/account/subscriptions");
  const { Browser } = await import("@capacitor/browser");
  await Browser.open({ url });
}
